import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-attr-shape-01",
  "use": "icon-attr-shape-01-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-attr-shape-01\"><path d=\"M22.555 28H9.445c-.604 0-1.139-.406-1.325-1.007L4.068 13.961c-.186-.6.018-1.258.507-1.629L15.18 4.278c.488-.37 1.15-.37 1.638 0l10.606 8.054c.489.371.693 1.03.507 1.63l-4.051 13.03c-.187.6-.722 1.007-1.326 1.007z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol